
import api from '@/plugins/api'
import eventBus from '../../plugins/eventBus'
import SButton from '@/components/SButton.vue'
import STextField from '@/components/STextField.vue'
import { UserModel } from '@/store/models/UserModel'
import { Component, Vue, Watch } from 'vue-property-decorator'

@Component({
  components: { SButton, STextField },
})
export default class SendCredits extends Vue {
  clientCredits: number = 0
  validationErrorShow: boolean = false
  validationErrorMsg: string = ''
  request: any = {
    receiver_email: '',
    value: 0,
  }
  user: UserModel = UserModel.getInstance()

  get creditCalculation() {
    let creditDifference = this.clientCredits - this.request.value
    if (creditDifference < 0 || this.request.value < 0) {
      return 0
    } else return creditDifference
  }

  sendCredits() {
    if (!this.request.receiver_email || !this.request.value) {
      return alert('Plotësoni fushat!')
    }
    if (this.validationErrorShow) {
      return alert('Email nuk është në formatin e duhur!')
    }
    this.user.transferCredits(this.request)
  }

  mounted() {
    this.getClientTotalCredits()
    eventBus.$on('credits:transfered', () => {
      this.request.receiver_email = ''
      this.request.value = 0
      this.getClientTotalCredits()
    })
  }

  getClientTotalCredits() {
    api()
      .get('me/total-credit')
      .then((response: any) => {
        this.clientCredits = parseInt(String(response.data).split(',').join(''))
      })
  }

  @Watch('request.receiver_email')
  onRecieverEmailChange(from: any, to: any) {
    if (!this.request.receiver_email) {
      return (this.validationErrorMsg = 'Plotësoni fushën!')
    }

    let pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!pattern.test(this.request.receiver_email)) {
      this.validationErrorMsg = 'Email nuk është në formatin e duhur!' + this.$t('messages.wrongEmail')
      return (this.validationErrorShow = true)
    }
    this.validationErrorShow = false
  }
}
